import { en } from './en';
import { pl } from './pl';

export const SUPPORTED_LOCALES = [
  { code: 'en', name: 'English', flag: 'EN' },
  { code: 'pl', name: 'Polski', flag: 'PL' },
] as const;

export type Language = (typeof SUPPORTED_LOCALES)[number]['code'];
export type LocaleDictionary = Record<string, string>;

export const dictionaries: Record<Language, LocaleDictionary> = { en, pl };

if (import.meta.env.DEV) {
  const englishKeys = Object.keys(en);
  for (const locale of SUPPORTED_LOCALES) {
    const missingKeys = englishKeys.filter((key) => !(key in dictionaries[locale.code]));
    if (missingKeys.length) console.warn(`Locale ${locale.code} is missing keys:`, missingKeys);
  }
}
